var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavBus = function SvgNavBus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.6,
    cy: 17,
    r: 1.5,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.6,
    cy: 17,
    r: 1.5,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2 4.5H2.9M23.6 13.5h-21"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M23.1 2.7c0-1-.9-1.7-1.8-1.7H4.9C3.9 1 3 1.7 3 2.7L2.6 14v6.3c0 .4.3.7.7.7h19.6c.4 0 .7-.3.7-.7V14z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 21v1.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V21M21.5 21v1.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "M14.9 16.5h-3.8c-.3 0-.6.3-.6.6v.8c0 .3.3.6.6.6h3.8c.3 0 .6-.3.6-.6v-.8c0-.3-.3-.6-.6-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2.5 13.5h-1c-.6 0-1-.4-1-1v-2c0-.6.4-1 1-1h1M23.5 13.5h1c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1h-1"
  }))));
};
export default SvgNavBus;